import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { CampaignQuoteModel } from '@models/campaignQuote'

import { generateUrls } from '@hooks/useCampaignQuote'

const generateTabBarItems = (campaignQuote: CampaignQuoteModel) => {
  const urls = generateUrls(campaignQuote, {
    prefixRoute: `campaigns/${campaignQuote.campaign_id}/edit`,
  })

  const { editCampaignQuoteUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editCampaignQuoteUrl,
      key: 'details',
      title: campaignQuote?.title || 'Loading...',
    },
  ]
}

export default generateTabBarItems
